import React from "react";
import { NavLink } from "react-router-dom";

function Navbar() {
  return (
    <header className="navbar">
      <div className="nav-inner">

        {/* Logo + Brand */}
        <div className="logo-area">
          <img src="/logo.png" alt="Rooftech Logo" className="logo-img" />
          <span className="logo-main">ROOFTECH</span>
        </div>

        {/* Navigation */}
        <nav className="nav-links">
          <NavLink to="/" end>Home</NavLink>
          <NavLink to="/puf-panels">PUF Panels</NavLink>
          <NavLink to="/false-ceilings">False Ceilings</NavLink>
          <NavLink to="/raised-flooring">Raised Flooring</NavLink>
          <NavLink to="/clean-rooms">Clean Rooms</NavLink>
          <NavLink to="/safety-barriers">Safety Barriers</NavLink>
          <NavLink to="/acoustic-windows-doors">DGU Windows</NavLink>
        </nav>

      </div>
    </header>
  );
}

export default Navbar;